/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import Footer from "../components/main/Footer"
import Basket from "../components/organisms/Basket"
import { Header } from "../components/organisms/Header"
import { Topbar } from "../components/organisms/Topbar"
import { TENANTS } from "../constants"
import ApiService from "../core/service/ApiService"
import { getCountryFromLanguage, sendToLogServer } from "../core/service/BusinessLogicService"
import { initPdiComponent } from "../core/service/BusinessLogicService"
import { loc } from "../core/utils"
import { Logger } from "../service/Logger"
import React, { Component } from "react"
import { Alert, Col, Container, Row } from "react-bootstrap"

const END_EVENT_TYPE = "endEvent"
const USER_EVENT_TYPE = "userEvent"
const CLIENT_FILE_EVENT_TYPE = "clientFileEvent"
const EXIT_EVENT_TYPE = "exitEvent"
const ERROR_EVENT_TYPE = "errorEvent"
const CHECK_CLAUSE_ACTION = "CHECK_CLAUSE"

class NetheosPage extends Component {
  contractFinalizationHandled = false

  componentDidMount() {
    initPdiComponent("NetheosPage")
    const { tunnelData } = this.props

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
    this.loadSignbookScript(tunnelData)
  }

  loadSignbookScript = (tunnelData) => {
    const scriptUrl = `${tunnelData.netheosIFrameUrlBase}contract/signbook/v3/script/signbook.js`
    const existingScript = document.querySelector(`script[src="${scriptUrl}"]`)

    if (!existingScript) {
      const script = document.createElement("script")
      script.src = scriptUrl
      script.async = true
      script.onload = this.initializeSignbook.bind(this, tunnelData)
      script.onerror = () => {
        this.handleNetheosIFrameOpening(tunnelData)
      }
      document.body.appendChild(script)
    } else {
      console.log("🔄 signbook.js already loaded .")
      this.initializeSignbook(tunnelData)
    }
  }

  initializeSignbook = (tunnelData) => {
    const signbookUrl = `${tunnelData.netheosIFrameUrlBase}contract/signbook/signbook.html`
    const lang = tunnelData?.data?.order?.orderLanguageTag?.split("-")?.[0]
    const signbookUrlWithLang = lang ? `${signbookUrl}?lang=${encodeURIComponent(lang)}` : signbookUrl
    if (window.NthSignbook) {
      new window.NthSignbook({
        iframeSelectorId: "contractSignatureFrame",
        token: tunnelData.netheosToken,
        url: signbookUrlWithLang,
        options: {
          bankAccountMode: "redirect",
          renderMode: "pretty",
          ...(lang ? { lang } : {})
        }
      })
      console.log("✅ Signbook initialized successfully !")
      this.initNetheosHandlers(tunnelData)
    } else {
      console.error("NthSignbook not defined !")
      this.handleNetheosIFrameOpening(tunnelData)
    }
  }

  render() {
    const { tunnelData } = this.props
    const { tenant } = tunnelData
    console.log("TUNNEL DATA DANS LE RENDER DE NETHEOS", tunnelData)
    console.log("Néthéos render page : uuid =", tunnelData.netheosToken)
    return tunnelData.nativeNetheos ? (
      <div id="iframe-wrapper">
        <iframe
          id="contractSignatureFrame"
          allow="camera;microphone"
          title="Documents Signature Frame"
          style={{ width: "100%", minHeight: "100vh", border: "none" }}
        />
      </div>
    ) : (
      <Container fluid>
        <Row noGutters>
          {/* ——————————————————————————————————————————————— */}
          {/* ———————————————————— MAIN ————————————————————— */}
          {/* ——————————————————————————————————————————————— */}
          <Col className="main-block">
            <Row>
              <Topbar tunnelData={this.props?.tunnelData} history={this.props?.history} />
              <Header tunnelData={this.props?.tunnelData} />
              <Col sm={12}>
                {/* CONTENT */}
                <Container>
                  {getCountryFromLanguage(tunnelData.data.order.orderLanguageTag) !== "ES" && (
                    <Row>
                      <Col>
                        <Alert variant="info">
                          <p>
                            {loc`Read each document (tab), download your supporting documents. You will be able to accept the conditions of the contract by checking the boxes and electronically sign your contract with a code that you will receive by SMS.`}
                          </p>
                        </Alert>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <div id="iframe-wrapper">
                        <iframe
                          id="contractSignatureFrame"
                          allow="camera;microphone"
                          title="Documents Signature Frame"
                          style={{ width: "100%", minHeight: "100vh", border: "none" }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Container>
                {/* END CONTENT */}
              </Col>
              <Col sm={12}>
                <Container>
                  <Footer tunnelData={this.props?.tunnelData} />
                </Container>
              </Col>
            </Row>
          </Col>

          {/* ————————————————————————————————————————————————— */}
          {/* ————————————————————— ASIDE ————————————————————— */}
          {/* ————————————————————————————————————————————————— */}

          <Col className="aside-block d-none d-lg-block d-xl-block" lg={4}>
            <Basket tunnelData={this.props?.tunnelData || null} />
          </Col>
        </Row>
      </Container>
    )
  }

  handleNetheosIFrameOpening(tunnelData) {
    // should be returnUrl according to swagger documentation
    const tokenNetheos = tunnelData.netheosToken
    const iframeSrc = `${tunnelData.netheosIFrameUrl + tokenNetheos}&renderMode=pretty&bankAccountMode=redirect&lang=${
      tunnelData.data.order.orderLanguageTag.split("-")[0]
    }`
    Logger.info("URL de l'iframe:" + iframeSrc, false, tunnelData)
    const textToRetrieve = `<iframe id="contractSignatureFrame" allow="camera;microphone" title="Documents Signature Frame" src="${iframeSrc}" style="width: 100%; min-height: 100vh; border: none;"></iframe>`
    document.getElementById("iframe-wrapper").innerHTML = textToRetrieve
    this.initNetheosHandlers(tunnelData)
  }

  initNetheosHandlers(tunnelData) {
    const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent"
    const eventer = window[eventMethod]
    const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message"
    const signatureApiBaseUrl = `${tunnelData.apiUrl}middle-business-service/api/v2/order/${tunnelData.opl}/signature/${tunnelData.netheosToken}`
    const { history, onSetStep } = this.props
    const token = tunnelData.access_token
    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: "*/*",
      "Content-Type": "application/json"
    }

    const MESSAGE_TITLES = {
      EXIT: "A bientôt !",
      SUSPENDED: "Pièces justificatives en cours de contrôle",
      FINALIZED: "Dossier complet",
      WAITING: "Dossier en cours de validation",
      ACCEPTED: "Félicitations !",
      REJECTED: "Désolé"
    }

    const MESSAGE_TEXTS = {
      EXIT: "Vous pouvez revenir quand vous le souhaitez compléter votre dossier.",
      SUSPENDED:
        "Une ou plusieurs des pièces que vous avez soumises sont en cours d'examen par nos opérateurs. Merci de revenir plus tard.",
      FINALIZED: "Votre dossier est désormais complet, nous vous recontacterons quand nous l'aurons examiné.",
      WAITING: "Votre dossier est en cours d'examen.",
      ACCEPTED: "Votre dossier a été accepté.",
      REJECTED: "Votre dossier a été refusé.",
      SIGNATURE_REJECTED: "Votre dossier est annulé, la signature du contrat a été refusée.",
      TOO_MANY_OTP_TRIES: "Votre dossier est annulé, trop de code OTP erronés envoyés lors de la signature.",
      DOC_SUBMISSION_ERROR: "Votre dossier est annulé, les documents soumis sont refusés par notre application."
    }

    eventer(
      messageEvent,
      async (event) => {
        let jsEvent = {}
        try {
          if (event.data.source) {
            jsEvent = event.data
          } else if (event.data.data) {
            jsEvent = JSON.parse(event.data.data)
          } else if (event.data) {
            jsEvent = JSON.parse(event.data)
          } else {
            jsEvent = event
          }
        } catch (e) {
          console.error("error netheos Token parsing Event data : \n", e)
        }

        if (jsEvent.type) {
          console.log("\n=============\n")
          console.log("Netheos jsEvent : \n", jsEvent)
          if (jsEvent.type === END_EVENT_TYPE) {
            console.warning("END_EVENT_TYPE Detected ! ", jsEvent)
            console.log("Exiting the page")
          } else if (jsEvent.type === USER_EVENT_TYPE) {
            // All user actions => used by web analytics libraries like Google Analytics
            console.log("USER_EVENT ACTION : " + jsEvent.action)

            if (jsEvent.action === CHECK_CLAUSE_ACTION) {
              console.log("CHECK_CLAUSE_ACTION : \n")
              if (jsEvent.context.checked === true) {
                console.log("CHECK_CLAUSE_ACTION : OK")
                ApiService.postForEvollisApi(signatureApiBaseUrl + "/log-user-event/CHECK_CLAUSE_OK", null, { headers })
              } else {
                console.log("CHECK_CLAUSE_ACTION : KO")
                ApiService.postForEvollisApi(signatureApiBaseUrl + "/log-user-event/CHECK_CLAUSE_KO", null, { headers })
              }
            } else {
              console.log("USER_EVENT OTHER ACTION : ", jsEvent.action, jsEvent)
              ApiService.postForEvollisApi(signatureApiBaseUrl + "/log-user-event/" + jsEvent.action, null, { headers })
            }
          } else if (jsEvent.type === CLIENT_FILE_EVENT_TYPE) {
            console.log("CLIENT_FILE_EVENT_TYPE STATE: \n", jsEvent.state)
            // Event coming from eKeynox SaaS with data concerning the state of the client file

            if (
              (jsEvent.changedState &&
                jsEvent.changedState.from === "PENDING" &&
                (jsEvent.changedState.to === "WAITING" || jsEvent.changedState.to === "ACCEPTED")) ||
              jsEvent.participantState === "WAITING"
            ) {
              if (this.contractFinalizationHandled) {
                return
              }
              this.contractFinalizationHandled = true

              console.log(MESSAGE_TITLES["FINALIZED"])
              console.log("jsEvent.changedState : \n", jsEvent.changedState)

              await ApiService.postForEvollisApi(signatureApiBaseUrl + "/contract/events/end", null, { headers })

              sendToLogServer("INFO", "NETHEOS jsEvent result for " + tunnelData.opl + " : " + JSON.stringify(jsEvent))

              console.log("final request has been sent to Evollis' API")

              // Priorité au next step global (même logique que les autres pages du tunnel)
              if (typeof onSetStep === "function") {
                onSetStep()
              } else if (tunnelData.tenant === TENANTS.MEDIAMARKT_NL || tunnelData.tenant === TENANTS.MEDIAMARKT_BE) {
                // Fallback legacy : MediaMarkt NL/BE vers CB après Netheos
                history.push("/digital-journey/cb")
              } else {
                history.push("/digital-journey/final")
              }
            } else if (jsEvent.state === "PENDING" && jsEvent.context.type === "signatureRefusal") {
              console.log(MESSAGE_TEXTS["SIGNATURE_REJECTED"])

              ApiService.postForEvollisApi(signatureApiBaseUrl + "/contract/events/signatureRefusal", null, { headers })

              history.push("/digital-journey/score-ko")
            } else if (jsEvent.state === "REJECTED") {
              console.log(MESSAGE_TEXTS[jsEvent.cause])
              sendToLogServer("INFO", "Netheos rejet automatique de la commande : " + tunnelData.opl + " : " + ". Détails : " + JSON.stringify(jsEvent));
              let cause = jsEvent.cause ? jsEvent.cause : "DOC_SUBMISSION_ERROR";
              ApiService.postForEvollisApi(signatureApiBaseUrl + "/contract/events/" + cause, null, { headers })
              history.push("/digital-journey/score-ko")
            } else {
              if (jsEvent.state !== "PENDING") {
                console.log(MESSAGE_TEXTS[jsEvent.state])
              }
            }
          } else if (jsEvent.type === EXIT_EVENT_TYPE) {
            console.log("EXIT_EVENT_TYPE STATE: \n")
            console.log(MESSAGE_TEXTS["EXIT"])
            ApiService.postForEvollisApi(signatureApiBaseUrl + "/contract/events/exit", null, { headers })
            history.push("/digital-journey/signature-paused")
          } else if (jsEvent.type === ERROR_EVENT_TYPE) {
            console.log("ERROR_EVENT_TYPE STATE: \n")
            if (jsEvent.cause !== "INVALID_STATE") {
              ApiService.postForEvollisApi(signatureApiBaseUrl + "/contract/events/INVALID_STATE", null, { headers })
            } else {
              ApiService.postForEvollisApi(signatureApiBaseUrl + "/contract/events/errors", null, { headers })
            }
          }
        }
      },
      false
    )
  }
}

export default NetheosPage
